<template>
    <form @submit.prevent="handleSubmit">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Create {{ selectedType }}</p>
            </header>
            <section class="modal-card-body">
                <o-field v-if="! preselectedType" label="Type">
                    <o-select placeholder="Select a type" v-model="selectedType" expanded>
                        <option :value="null" disabled>Not Specified</option>
                        <option v-for="type in Object.keys(types)" :value="type">{{ type }}</option>
                    </o-select>
                </o-field>
                <occupancy-certificate
                        v-if="selectedType === 'Certificate of Occupancy'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <after-hours-permit
                        v-if="selectedType === 'After Hours Permit'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <determination
                        v-if="selectedType === 'Determination'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <misc-service
                        v-if="selectedType === 'Misc Service'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <inspection
                        v-if="selectedType === 'Inspection'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <dot-permit
                        v-if="selectedType === 'DOT Permit'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <violation
                        v-if="selectedType === 'Violation'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <tracking
                        v-if="selectedType === 'Tracking'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <filing
                        v-if="selectedType === 'Filing'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
                <permit
                        v-if="selectedType === 'Permit'"
                        :application="application"
                        :errors-prop="errors"
                        v-model="form"
                />
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="handleClose">Close</button>
                <button v-if="selectedType" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import HandlesForm from '../../../mixins/HandlesForm'
    import { mapActions } from 'vuex'

    import OccupancyCertificate from './OccupancyCertificate'
    import AfterHoursPermit from './AfterHoursPermit'
    import Determination from './Determination'
    import MiscService from './MiscService'
    import Inspection from './Inspection'
    import DotPermit from './DotPermit'
    import Violation from './Violation'
    import Tracking from './Tracking'
    import Filing from './Filing'
    import Permit from './Permit'
    import Application from "../../../mixins/Application";

    export default {
        mixins: [HandlesForm, Application],

        props: ['application', 'preselected-type'],

        components: {
            OccupancyCertificate,
            AfterHoursPermit,
            Determination,
            MiscService,
            Inspection,
            DotPermit,
            Violation,
            Tracking,
            Filing,
            Permit
        },

        data () {
            return {
                types: {
                    ['After Hours Permit']: this.createOrUpdateAfterHoursPermit,
                    ['Determination']: this.createOrUpdateDetermination,
                    ['DOT Permit']: this.createOrUpdateDotPermit,
                    ['Filing']: this.createOrUpdateFiling,
                    ['Inspection']: this.createOrUpdateInspection,
                    ['Misc Service']: this.createOrUpdateMiscService,
                    ['Certificate of Occupancy']: this.createOrUpdateOccupancyCertificate,
                    ['Permit']: this.createOrUpdatePermit,
                    ['Tracking']: this.createOrUpdateTracking,
                    ['Violation']: this.createOrUpdateViolation
                },
                selectedType: '',
                // form: null
            }
        },

        mounted () {
            this.selectedType = ""
            if (this.preselectedType) {
                this.selectedType = this.preselectedType
            }

            this.fetchContacts()
        },

        computed: {
            createOrUpdate () {
                return this.types[this.selectedType]
            }
        },

        methods: {
            ...mapActions({
                createOrUpdateAfterHoursPermit: 'after-hours-permits/createOrUpdate',
                createOrUpdateDetermination: 'determinations/createOrUpdate',
                createOrUpdateDotPermit: 'dot-permits/createOrUpdate',
                createOrUpdateFiling: 'filings/createOrUpdate',
                createOrUpdateInspection: 'inspections/createOrUpdate',
                createOrUpdateMiscService: 'misc-services/createOrUpdate',
                createOrUpdateOccupancyCertificate: 'occupancy-certificates/createOrUpdate',
                createOrUpdatePermit: 'permits/createOrUpdate',
                createOrUpdateTracking: 'trackings/createOrUpdate',
                createOrUpdateViolation: 'violations/createOrUpdate',
                fetchContacts: 'fetchContacts'
            }),

            handleSubmit () {
                let submit = this.wrapSubmit(this.createOrUpdate)

                submit(this.form)
                    .then(res => {
                        this.$emit('select', res.data.data)
                        this.successMessage(`${this.selectedType} has been successfull created`)
                        this.form = {}
                        this.$parent.$parent.cancel('button');
                        return res
                    })
            },

            handleClose () {
              this.$parent.$parent.cancel('button');
            },


        }
    }
</script>
